module.exports = __webpack_public_path__ + "static/media/protegetusdatos.84bfa6ca.png";